export const BLOG_ITEM_STATUS = [
  'DRAFT',
  'SCHEDULED',
  'PUBLISHED',
  'DELETED',
] as const;

export type BlogItemStatusT = typeof BLOG_ITEM_STATUS[number];

export type BlogItemQueryT = {
  asEndUser?: boolean;
  textSearch?: string;
};

export type BlogItemT = {
  category: string;
  content: string;
  headVideoHeight?: null | number;
  headVideoWidth?: null | number;
  id?: string;

  /** BEWARE: This now also can be a video URL! */
  image?: null | string;

  __v?: number;
  imageThumbnail?: null | string;
  isHeadMediaReady?: boolean | null;
  publishedAt?: null | number;
  status: BlogItemStatusT;
  summary: string;
  title: string;
};

export function evalSummaryError(value: string): null | string {
  const { length } = value;

  if (length < 50) {
    return `Must be longer than 50 characters (currently ${length}).`;
  }

  if (length > 300) {
    return `Must be shorter than 300 characters (currently ${length}).`;
  }

  return null;
}

export function evalTitleError(title: string): null | string {
  if (title.trim().length < 3) return 'A valid title is required';

  return null;
}

export function canBePublished(item: BlogItemT): boolean {
  return !evalTitleError(item.category)
    && !!item.content
    && !!item.image
    && !!item.imageThumbnail
    && !evalSummaryError(item.summary)
    && !evalTitleError(item.title);
}

export const BLOG_TEXT_SEARCH_INDEX_NAME = 'BlogTextSearch';

export const DEFAULT_BLOG_PAGE_SIZE = 20;
